// removed by extract-text-webpack-plugin
module.exports = {"alert":"PageLevelError__alert","alert-content":"PageLevelError__alert-content","alertContent":"PageLevelError__alert-content"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelError/PageLevelError.scss
// module id = 1494
// module chunks = 8